<template>
    <div class="ngdialog-content">
        <div class="ngdialog-close" @click="$emit('close')"></div>
        <form name="resetForm" @submit.prevent="requestResetPassword" class="form">
            <div class="ngdialog__body">
                <p v-html="$t('registration.pwreset_begin_welcome')"></p>

                <div
                    class="alert alert--success"
                    role="alert"
                    v-show="success"
                >{{$t('registration.pwreset_begin_success')}}</div>
                <div
                    class="alert alert--danger"
                    role="alert"
                    v-show="responseCode === 404"
                >{{$t('registration.pwreset_begin_not_found')}}</div>

                <div class="form__row">
                    <input
                        type="email"
                        class="form__field"
                        id="email"
                        name="email"
                        :placeholder="$t('fields.email')"
                        v-model.trim="$v.formData.email.$model"
                    >

                    <div v-if="$v.formData.email.$error">
                        <p
                            class="form__error"
                            v-show="!$v.formData.email.required"
                        >{{$t('fields.email_e_required')}}</p>

                        <p
                            class="form__error"
                            v-show="!$v.formData.email.email"
                        >{{$t('fields.email_e_email')}}</p>
                    </div>
                </div>
            </div>

            <div class="ngdialog__button-group">
                <div class="ngdialog__button-group__item" v-show="!success">
                    <a
                        class="ngdialog__button ngdialog__button--secondary"
                        @click="$emit('close')"
                        same-height="dialog-button"
                    >
                        <span class="ngdialog__button__text">{{$t('buttons.cancel')}}</span>
                    </a>
                </div>

                <div class="ngdialog__button-group__item" v-show="!success">
                    <button type="submit" class="ngdialog__button" same-height="dialog-button">
                        <span class="ngdialog__button__text">{{$t('buttons.continue')}}</span>
                    </button>
                </div>

                <div class="ngdialog__button-group__item" v-show="success">
                    <a class="ngdialog__button" @click="$emit('close')" same-height="dialog-button">
                        <span class="ngdialog__button__text">{{$t('buttons.close')}}</span>
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import * as api from '@/api';
import { required, email } from 'vuelidate/lib/validators';

export default {
    data() {
        return {
            formData: {
                email: '',
            },
            responseCode: false,
            success: false,
        };
    },
    validations: {
        formData: {
            email: {
                required,
                email,
            },
        },
    },
    methods: {
        requestResetPassword() {
            if (this.$v.formData.$invalid) {
                this.$v.formData.$touch();
                return;
            }
            api.users.requestResetPassword({email: this.formData.email}).then(
                () => {
                    this.success = true;
                    this.responseCode = 200;
                },
                error => {
                    this.responseCode = error.response.status;
                }
            );
        },
    },
};
</script>
